module.exports = new __parcel__URL__("select-generic-csv.de6be5f2.svg").toString();